import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * URL 경로에서 특정 인덱스의 세그먼트를 가져오는 커스텀 훅
 * '/mobile/'이 포함된 경우 인덱스를 자동으로 조정합니다.
 *
 * @param {number} passIndex - 기본 인덱스 (기본값: 5)
 * @returns {string} 해당 인덱스의 경로 세그먼트 또는 존재하지 않는 경우 ""
 */
const usePathSegment = (passIndex = 5) => {
  const location = useLocation();
  const [segment, setSegment] = useState("");

  useEffect(() => {
    const pathname = location.pathname;
    const hasMobilePrefix = pathname.includes("/mobile/");
    const targetIndex = hasMobilePrefix ? passIndex + 1 : passIndex;
    const segments = pathname.split("/").filter(Boolean);
    setSegment(segments[targetIndex - 1] || "");
  }, [location.pathname, passIndex]);

  return segment;
};

export default usePathSegment;
